import React, {useEffect} from 'react';
import QrCodeDialog from './qr-code-dialog';
import styled from 'styled-components';
import {
  Text,
  TextAlignment,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import {config} from '../environment';
import {getHeader} from '../helpers/get-header';
import PhoneWallboxLanding from './phone-wallbox-landing';
import useMediaQuery from '../hooks/useMediaQuery';

const HeroTextContainer = styled.div<{isMobile?: boolean}>`
  & > div {
    font-size: ${({isMobile}) => (isMobile ? '32px' : '60px')};
  }
`;

const Background = styled.div<{isMobile: boolean}>`
  position: relative;
  background-image: ${(props) =>
    props.isMobile
      ? `url(${config.AMPOL_AMP_CHARGE_ASSETS_BASE_URL}VW-EVCharger-BG-Mobile.jpg)`
      : `url(${config.AMPOL_AMP_CHARGE_ASSETS_BASE_URL}VW-EVCharger-BG-Desktop.jpg)`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  padding: 40px 27px 50px 27px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: auto 0;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 32px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  margin-left: auto;
`;

const Description = styled.div`
  max-width: 440px;
  margin-top: 24px;

  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 16px;
  }
`;

const PhoneWrapper = styled.div<{isMobile: boolean}>`
  ${({isMobile}) =>
    isMobile
      ? `
    transform: translateX(-50%);
    left: 57%;
    position: relative;
    width: fit-content;
  `
      : 'margin: 0 auto;'}
`;

type Props = {
  isCustomers?: boolean;
};

const LandingScreen: React.FC<Props> = ({isCustomers}) => {
  const {isMobile} = useMediaQuery();

  useEffect(() => {
    const header = getHeader();
    if (header) {
      header.classList.remove('ev-hub-hidden');
    }
  }, []);

  return (
    <Background isMobile={isMobile}>
      <Container>
        <ContentWrapper>
          <HeroTextContainer isMobile={isMobile}>
            <Text
              appearance={TokenTextAppearance.headline600}
              color={TokenTextColor.inherit}
              textAlign={TextAlignment.center}
            >
              {isCustomers ? 'Ready to get' : 'Pull up and'}
            </Text>
            <Text
              appearance={TokenTextAppearance.headline600}
              bold
              color={TokenTextColor.inherit}
              textAlign={TextAlignment.center}
            >
              {isCustomers ? 'powered up?' : 'get powered up'}
            </Text>
          </HeroTextContainer>
          <Description>
            <Text
              appearance={TokenTextAppearance.copy200}
              textAlign={TextAlignment.center}
              color={TokenTextColor.inherit}
            >
              {isCustomers
                ? 'This AR Experience will help you find your best home charging setup. You’ll then be able to snap some photos that can be used to complete your future AmpCharge EV charger installation application.'
                : 'Try our AR experience to visualise how the Ampol Wallbox Charger would look in your home'}
            </Text>
          </Description>
          <QrCodeDialog isCustomers={isCustomers} />
        </ContentWrapper>
        <PhoneWrapper isMobile={isMobile}>
          <PhoneWallboxLanding {...(isMobile && {width: 235, height: 368})} />
        </PhoneWrapper>
      </Container>
    </Background>
  );
};

export default LandingScreen;
